/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitEntityMappingQueries
 */
export interface MonitEntityMappingQueries {
    /**
     * 
     * @type {number}
     * @memberof MonitEntityMappingQueries
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitEntityMappingQueries
     */
    page_size?: number;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityMappingQueries
     */
    domain?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityMappingQueries
     */
    type?: string;
}

/**
 * Check if a given object implements the MonitEntityMappingQueries interface.
 */
export function instanceOfMonitEntityMappingQueries(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitEntityMappingQueriesFromJSON(json: any): MonitEntityMappingQueries {
    return MonitEntityMappingQueriesFromJSONTyped(json, false);
}

export function MonitEntityMappingQueriesFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntityMappingQueries {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'domain': !exists(json, 'domain') ? undefined : json['domain'],
        'type': !exists(json, 'type') ? undefined : json['type'],
    };
}

export function MonitEntityMappingQueriesToJSON(value?: MonitEntityMappingQueries | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'domain': value.domain,
        'type': value.type,
    };
}

